import * as React from "react";
import {
  FormControl,
  InputAdornment, InputLabel, MenuItem,
  TextField,
  Select
} from "@mui/material";

import CompanyIcon from "@mui/icons-material/Business";
import { Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import RequiredAsterisk from "../../components/RequiredAsterisk";
import AddressAutocompleteInput from "../../components/AddressAutocompleteInput";
import { useAddressAutofill } from "../../hooks/useAddressAutofill";


const DeliveryAddress = ({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => {
  // handleChange here is CheckOutForm1's enhancedHandleChange, so routing the
  // autofill's setters through it keeps the delivery-service/branch side effects in sync.
  const fireChange = (name, value) => handleChange({ target: { name, value } });

  const { suburbs, postcodes, handleSuburbValueChange, handlePostcodeValueChange } = useAddressAutofill({
    state: values.delivery_state,
    setState: (value) => fireChange('delivery_state', value),
    setSuburb: (value) => fireChange('delivery_suburb', value),
    setPostcode: (value) => fireChange('delivery_postcode', value),
  });

  return (
    <Formik
      initialValues={values}
      onSubmit={handleSubmit}
    >
      <div className="mb-4">

        <Row className="mb-4 g-2">

          <Col xs={12}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_company" label="Company name (if Applicable)"
                value={values.delivery_company}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'><CompanyIcon /></InputAdornment>
                  )
                }}
              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_firstname" label={<>Firstname <RequiredAsterisk /></>}
                value={values.delivery_firstname}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(touched?.delivery_firstname && errors.delivery_firstname)}
                helperText={touched?.delivery_firstname && errors.delivery_firstname}

              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_lastname" label={<>Lastname <RequiredAsterisk /></>}
                value={values.delivery_lastname}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(touched?.delivery_lastname && errors.delivery_lastname)}
                helperText={touched?.delivery_lastname && errors.delivery_lastname}

              />
            </FormControl>

          </Col>


          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <TextField name="delivery_number_street" label={<>Number & Street <RequiredAsterisk /></>}
                value={values.delivery_number_street}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(touched?.delivery_number_street && errors.delivery_number_street)}
                helperText={touched?.delivery_number_street && errors.delivery_number_street}

              />
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <div className={`mui-like-field${touched?.delivery_suburb && errors.delivery_suburb ? ' mui-like-field-error' : ''}`}>
                <span className="mui-like-label">Suburb/Town <RequiredAsterisk /></span>
                <AddressAutocompleteInput
                  name="delivery_suburb"
                  value={values.delivery_suburb}
                  onChange={(value) => fireChange('delivery_suburb', value)}
                  onBlur={handleBlur}
                  options={suburbs}
                  onValueChange={handleSuburbValueChange}
                  placeholder="Suburb or Town"
                />
              </div>
              {touched?.delivery_suburb && errors.delivery_suburb && (
                <div className="mui-like-helper-text">{errors.delivery_suburb}</div>
              )}
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <InputLabel id="owner-state-label">State <RequiredAsterisk /></InputLabel>
              <Select name="delivery_state"
                defaultValue=""
                labelId="delivery-state-label"
                id="delivery-state"
                label="State *"
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.delivery_state}
                error={!!(touched?.delivery_state && errors.delivery_state)}
              >
                <MenuItem selected value=""><em>None</em></MenuItem>
                <MenuItem value="ACT">Australian Capital Territory</MenuItem>
                <MenuItem value="NSW">New South Wales</MenuItem>
                <MenuItem value="NT">Northern Territory</MenuItem>
                <MenuItem value="QLD">Queensland</MenuItem>
                <MenuItem value="SA">South Australia</MenuItem>
                <MenuItem value="TAS">Tasmania</MenuItem>
                <MenuItem value="VIC">Victoria</MenuItem>
                <MenuItem value="WA">Western Australia</MenuItem>
              </Select>
              {touched?.delivery_state && errors.delivery_state && (
                <div style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px', paddingTop: '2px' }}
                  className="text-danger">{errors.delivery_state}</div>
              )}
            </FormControl>

          </Col>

          <Col xs={12} sm={6}>

            <FormControl fullWidth className="mb-1">
              <div className={`mui-like-field${touched?.delivery_postcode && errors.delivery_postcode ? ' mui-like-field-error' : ''}`}>
                <span className="mui-like-label">Postcode <RequiredAsterisk /></span>
                <AddressAutocompleteInput
                  name="delivery_postcode"
                  value={values.delivery_postcode}
                  onChange={(value) => fireChange('delivery_postcode', value)}
                  onBlur={handleBlur}
                  options={postcodes}
                  onValueChange={handlePostcodeValueChange}
                  placeholder="Postcode"
                />
              </div>
              {touched?.delivery_postcode && errors.delivery_postcode && (
                <div className="mui-like-helper-text">{errors.delivery_postcode}</div>
              )}
            </FormControl>

          </Col>

        </Row>
      </div>
    </Formik>
  );
};

export default DeliveryAddress;
